import AJAX from 'utils/ajax'
import Quimbee from 'quimbee'

export default class UserPreferences {
  constructor() {
    this.getPreferencesPath = "/preferences.json"
    this.putPreferencePath = "/preferences/{{id}}.json"
  }

  async list() {
    if (Quimbee.isSignedInUser) {
      const response = await AJAX.get(this.getPreferencesPath)
      return await response.json()
    } else {
      return []
    }
  }

  async get(preference){
    if (Quimbee.isSignedInUser) {
      const preferences = await new Promise((resolve, reject) => { this._waitForUserPreferences(resolve, reject, 0) })
      return preferences[preference]
    } else {
      return {}
    }
  }

  async update(preference, value) {
    if (Quimbee.isSignedInUser) {
      await AJAX.put(this.putPreferencePath.interpolateObject({ id: preference }), { value: value })

      Quimbee.data.userPreferences[preference] = value
      window.dispatchEvent(new CustomEvent(`user-preferences.${preference}.updated`, {
        detail: {
          key: preference,
          newValue: value
        }
      }))

      return Quimbee.data.userPreferences
    } else {
      return {}
    }
  }

  async _waitForUserPreferences(resolve, reject, iteration) {
    if (Quimbee.data && Quimbee.data.userPreferences) {
      resolve(Quimbee.data.userPreferences)
    } else if (iteration <= 20) {
      // Retry every 0.5 seconds for 10 seconds before erroring
      setTimeout(this._waitForUserPreferences.bind(this, resolve, reject, iteration + 1), 500)
    } else {
      reject(new Error("Quimbee.data.userPreferences not available"))
    }
  }
}
